<template>
<div :class="$style.wrapper">
  <svg :class="$style.icon" svg-inline="" v-if="this.showIcon" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="31" r="12" fill="none" transform="translate(-15 -18)" stroke="#F7C11C" stroke-width="2"/></svg>
  <input
    :type="type"
    :class="$style.input"
    :style="{ paddingLeft: this.showIcon ? '3.8em' : '2.1em' }"
    :value="value"
    :placeholder="placeholder"
    @input="$emit('update', $event.target.value)"
    v-on="$listeners"
    autocomplete="off"
  />
</div>
</template>

<script>
export default {
  model: {
    event: 'update',
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
@import 'theme.scss';

.wrapper {
  display: flex;
  flex: 1;
  position: relative;
}

.icon {
  left: 1.6rem;
  position: absolute;
  top: 1.8rem;
}

.input {
  @extend %typography-small;
  background-color:$color-grocery-list-input-bg;
  border: 0;
  border-radius: $size-input-border-radius;
  font-size: 1.6rem;
  line-height: 1;
  padding: $size-input-padding-vertical + 0.6 $size-input-padding-horizontal $size-input-padding-vertical + 0.6 $size-input-padding-horizontal + 2.8;
  width: 100%;
}
</style>
